module.exports = __webpack_public_path__ + "static/media/Volkeno.ebfd9fa7.mp4";